import React from "react";

const UserManagementHeader = ({
  eyebrow,
  title,
  subtitle,
  total = 0,
  totalLabel,
  refreshLabel,
  onRefresh,
  refreshing = false
}) => (
  <header className="user-management-heading">
    <div className="user-management-heading-copy">
      {eyebrow && <p>{eyebrow}</p>}
      <h1>{title}</h1>
      {subtitle && <span>{subtitle}</span>}
    </div>
    <div className="user-management-heading-summary">
      <button
        type="button"
        className="user-management-refresh"
        aria-label={refreshLabel}
        title={refreshLabel}
        disabled={refreshing}
        onClick={onRefresh}
      >
        <i
          className={`fa-solid fa-rotate${refreshing ? " is-spinning" : ""}`}
          aria-hidden="true"
        />
      </button>
      <div className="account-total-pill">
        {totalLabel}: {Number(total) || 0}
      </div>
    </div>
  </header>
);

export default UserManagementHeader;
